export interface FormatCurrencyOptions {
  style?: 'currency'
  currency?: 'AUD'
  locale?: 'en-AU'
  /** Set true to return $4.00 as $4 but keep $4.50 as $4.50 */
  truncateZeros?: boolean
  minimumIntegerDigits?: number
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  minimumSignificantDigits?: number
  maximumSignificantDigits?: number
}

export function formatCurrency(value: number, options: FormatCurrencyOptions = {}): string {
  let {
    style = 'currency',
    currency = 'AUD',
    locale = 'en-AU',
    truncateZeros,
    minimumIntegerDigits,
    minimumFractionDigits,
    maximumFractionDigits,
    minimumSignificantDigits,
    maximumSignificantDigits,
  } = options

  if (truncateZeros) {
    /* Remove the 00s if possible. */
    const isWhole = value % 1 === 0
    if (isWhole) {
      minimumFractionDigits = 0
      maximumFractionDigits = 0
    }
  }

  const formatter = new Intl.NumberFormat(locale, {
    style,
    currency,
    minimumIntegerDigits,
    minimumFractionDigits,
    maximumFractionDigits,
    minimumSignificantDigits,
    maximumSignificantDigits,
  })

  return formatter.format(value)
}

export default formatCurrency
